import React, { useState } from "react";
import { usePlayer } from "@/context/PlayerContext";
import { Moon, X } from "lucide-react";

const OPTIONS = [5, 15, 30, 45, 60, 90];

export default function SleepTimerPanel({ onClose }) {
  const { sleepTimerMinutes, startSleepTimer, cancelSleepTimer, sleepRemaining } = usePlayer();
  const [custom, setCustom] = useState("");

  const active = sleepTimerMinutes > 0;
  const remaining = sleepRemaining;

  return (
    <div
      data-testid="sleep-panel"
      className="fixed bottom-24 left-1/2 -translate-x-1/2 z-50 w-[92%] max-w-md glass border border-white/10 p-5"
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Moon size={16} className="text-cyan-400" />
          <div>
            <div className="font-heading font-black text-base tracking-tight">SLEEP TIMER</div>
            <div className="font-mono-tech text-[10px] uppercase tracking-widest text-slate-500">FADE-OUT · THEN · STOP</div>
          </div>
        </div>
        <button
          data-testid="sleep-close"
          onClick={onClose}
          className="w-8 h-8 flex items-center justify-center text-slate-400 hover:text-white border border-[var(--voix-border)]"
        >
          <X size={14} />
        </button>
      </div>

      {active && (
        <div data-testid="sleep-active" className="mb-4 border border-cyan-500/40 bg-cyan-500/5 p-3">
          <div className="font-mono-tech text-[10px] uppercase tracking-widest text-cyan-400">RUNNING</div>
          <div className="font-heading font-bold text-2xl mt-1">
            {Math.floor(remaining / 60)}:{String(remaining % 60).padStart(2, "0")}
          </div>
          <button
            data-testid="sleep-cancel"
            onClick={cancelSleepTimer}
            className="mt-2 text-[10px] font-mono-tech uppercase tracking-widest text-pink-400 hover:text-pink-300"
          >
            Cancel timer
          </button>
        </div>
      )}

      <div className="grid grid-cols-3 gap-2">
        {OPTIONS.map((m) => (
          <button
            key={m}
            data-testid={`sleep-preset-${m}`}
            onClick={() => { startSleepTimer(m); onClose(); }}
            className={`border px-2 py-3 font-mono-tech text-[11px] uppercase tracking-widest transition ${
              sleepTimerMinutes === m
                ? "border-cyan-500 text-cyan-300 bg-cyan-500/10"
                : "border-[var(--voix-border)] text-slate-400 hover:border-cyan-500/60 hover:text-cyan-300"
            }`}
          >
            {m} min
          </button>
        ))}
      </div>

      <div className="mt-3 flex gap-2">
        <input
          data-testid="sleep-custom-input"
          type="number"
          min={1}
          max={480}
          value={custom}
          onChange={(e) => setCustom(e.target.value)}
          placeholder="Custom (min)"
          className="flex-1 bg-black/50 border border-[var(--voix-border)] px-3 py-2 text-sm font-mono-tech outline-none focus:border-cyan-500/60"
        />
        <button
          data-testid="sleep-custom-start"
          onClick={() => {
            const v = parseInt(custom, 10);
            if (v > 0) { startSleepTimer(v); onClose(); }
          }}
          className="border border-cyan-500 text-cyan-300 px-4 py-2 text-[10px] font-mono-tech uppercase tracking-widest hover:bg-cyan-500/10"
        >
          Start
        </button>
      </div>
    </div>
  );
}
